import { defineStaticListFilter } from '../engine/descriptor';
import { FilterId, FilterType } from '../types/filters';

export const PRESTIGE_SELECTIONS = [
  { value: '0', label: 'Very Low' },
  { value: '1', label: 'Low' },
  { value: '2', label: 'Medium' },
  { value: '3', label: 'High' },
  { value: '4', label: 'Very High' },
];

export const prestigeDescriptor = defineStaticListFilter({
  definition: {
    id: FilterId.PRESTIGE,
    name: 'Prestige',
    type: FilterType.STATIC_LIST,
    selections: [],
    isVisible: true,
  },
  multi: { id: FilterId.MULTI_PRESTIGE },
});
